// extracted by extract-css-chunks-webpack-plugin
module.exports = {"stockists":"css-1fEEN3tf50","stockists_country_title":"css-13vfKAbgEE","stockist":"css-1L5IQRJoLW","stockist_info":"css-Me6XB2rB3J"};